var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.type===0)?_c('PC'):_vm._e(),(_vm.type===1)?_c('LearningReport'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }